<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

// eslint-disable-next-line unicorn/prevent-abbreviations
const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div :class="cn('atabix-card-header', props.class)">
    <slot />
  </div>
</template>

<style lang="scss">
.atabix-card-header {
  @apply flex;
  @apply justify-between;
  @apply items-center;
  @apply gap-y-1.5;
  @apply px-6;
  @apply py-3;
}
</style>
